import BaseCameraStreamAction from './Actions/BaseCameraStreamAction';
import ConfigureCameraStreamAction from './Actions/ConfigureCameraStreamAction';

export const ACTION_NAMES = Object.freeze({
    CONFIGURE_CAMERA_STREAM: 'addCameraStreamConfiguration',
    ACTIVATE_CAMERA_STREAM_TYPE: 'activateStreamType',
    SOFT_REFRESH_CAMERA_STREAM: 'restart',
    STOP_CAMERA_STREAM: 'deactivate',
    RELEASE_CAMERA_STREAM: 'release',
    EDIT_ENDPOINT_TAGS: 'editWebRtcEndpointTransactionTag',
});

export const ACTION_TYPE = Object.freeze({
    [ACTION_NAMES.CONFIGURE_CAMERA_STREAM]: ConfigureCameraStreamAction,
    [ACTION_NAMES.ACTIVATE_CAMERA_STREAM_TYPE]: BaseCameraStreamAction,
    [ACTION_NAMES.SOFT_REFRESH_CAMERA_STREAM]: BaseCameraStreamAction,
    [ACTION_NAMES.STOP_CAMERA_STREAM]: BaseCameraStreamAction,
    [ACTION_NAMES.EDIT_ENDPOINT_TAGS]: BaseCameraStreamAction,
    [ACTION_NAMES.RELEASE_CAMERA_STREAM]: BaseCameraStreamAction,
});

export const ACTION_ORDER = Object.freeze([
    ACTION_NAMES.CONFIGURE_CAMERA_STREAM,
    ACTION_NAMES.ACTIVATE_CAMERA_STREAM_TYPE,
    ACTION_NAMES.STOP_CAMERA_STREAM,
    ACTION_NAMES.EDIT_ENDPOINT_TAGS,
    ACTION_NAMES.SOFT_REFRESH_CAMERA_STREAM,
    ACTION_NAMES.RELEASE_CAMERA_STREAM,
]);

export const ACTION_ARGS = Object.freeze({
    [ACTION_NAMES.CONFIGURE_CAMERA_STREAM]: {
        INVALIDATE_STREAM_CONFIGURATION: 'invalidateStreamConfiguration',
    },
});

export const SKIP_ACTIONS = Object.freeze([ACTION_NAMES.EDIT_ENDPOINT_TAGS]);
